import { render } from "./AdSpecification.vue?vue&type=template&id=ca66b1b4"
import script from "./AdSpecification.vue?vue&type=script&lang=js"
export * from "./AdSpecification.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__